/** Leaves the CRM for a Stripe page (payment, invoice, portal). */
export const openUrl = (url: string) => window.location.assign(url);
